import { React } from '../../../../../Imports';
import styled from '@emotion/styled';
import { Alert } from '../../../../../MaterialUIComponents';
import { Collapse, SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface IAlertProps {
    message: string;
    onClose?: () => void;
    backgroundColor: string;
    textColor: string;
    isVisible: boolean;
    muiIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
    iconColor: string;
    isBold?: boolean;
    borderRadius?: string;
}

type AlertProps = IAlertProps;
const StyledAlert = (props: AlertProps) => {
    const { message, onClose, isVisible = false, muiIcon, textColor, backgroundColor, iconColor, isBold = true, borderRadius } = props;

    const AlertStyled = styled(Alert)`
        background-color: ${backgroundColor};
        color: ${textColor};
        font-weight: ${isBold ? 600 : 400};
        border-radius: ${borderRadius || '0px'};
    `;

    const StyledIcon = styled(muiIcon)`
        color: ${iconColor};
    `;

    return (
        <Collapse in={isVisible} timeout={{ exit: 200, enter: 200 }}>
            <AlertStyled onClose={onClose} icon={<StyledIcon />}>
                {message}
            </AlertStyled>
        </Collapse>
    );
};

export default StyledAlert;
